import "./App.css";
import { useEffect } from "react";
import Main from "./Component/Main";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import productData, { siteConfig } from "./Datas/productData";

const routeTitles = {
  "/": "Raw denim & workwear",
  "/shop": "Shop",
  "/cartpage": "Your cart",
  "/checkout": "Secure checkout",
  "/paysuccess": "Order confirmed",
  "/about": "Our story",
  "/contact": "Contact",
  "/shipping": "Shipping",
  "/returns": "Returns",
  "/privacy": "Privacy policy",
  "/terms": "Terms & conditions",
};

function RouteEffects() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const productId = pathname.startsWith("/shopDetails/")
      ? Number(pathname.split("/").pop())
      : null;
    const product = productData.find((item) => item.id === productId);
    const pageTitle = product?.name || routeTitles[pathname] || "Raw denim & workwear";
    document.title = `${pageTitle} | ${siteConfig.brandName}`;

    const description = document.querySelector('meta[name="description"]');
    description?.setAttribute(
      "content",
      product?.description || siteConfig.description
    );
  }, [pathname]);

  return null;
}

function App() {
  return (
    <CartProvider>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <RouteEffects />
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
